import React, { useState } from 'react';
import logo from "../../../../src/assets/Whitelogo.svg";
import { X } from 'lucide-react';
import { useTheme } from '../../Layout/ThemeContext/ThemeContext';
// source="https://www.w3schools.com/html/mov_bbb.mp4",type="video"
export const MediaPlayer = () => {
  // const [isPlayerOpen, setIsPlayerOpen] = useState(isMediaopen);
  // const [mediaType, setMediaType] = useState(type); // "image" or "video"
  // const [mediaSource, setMediaSource] = useState(source);
  const [isPlaying, setIsPlaying] = useState(true);
  const [volume, setVolume] = useState(0.5);
  const {isPlayerOpen, setIsPlayerOpen,mediaType, setMediaType,mediaSource, setMediaSource} = useTheme()
  
  if (!isPlayerOpen) return ;

  // const openMediaPlayer = (type, source) => {
  //   setMediaType(type);
  //   setMediaSource(source);
  //   setIsPlayerOpen(true);
  // };

  const closeMediaPlayer = () => {
    setIsPlayerOpen(false);
    // setMediaSource('');
  };

  const togglePlayPause = () => {
    const mediaElement = document.getElementById('media-element');
    if (mediaType === 'video') {
      if (isPlaying) {
        mediaElement.pause();
      } else {
        mediaElement.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVolumeChange = (event) => {
    const newVolume = event.target.value;
    setVolume(newVolume);
    const mediaElement = document.getElementById('media-element');
    if (mediaElement) {
      mediaElement.volume = newVolume;
    }
  };

  return (
    <>
      {/* <h1 className="text-2xl font-bold mb-4">Full Media Player</h1>
      <button 
        onClick={() => openMediaPlayer('image', 'https://via.placeholder.com/600')} 
        className="bg-blue-500 text-white px-4 py-2 rounded mr-2 hover:bg-blue-600"
      >
        View Image
      </button>
      <button 
        onClick={() => openMediaPlayer('video', 'https://www.w3schools.com/html/mov_bbb.mp4')} 
        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
      >
        View Video
      </button> */}

      {isPlayerOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[7000]">
          <div className="bg-white rounded-lg overflow-hidden shadow-lg w-full max-w-4xl">
            
            {mediaType === 'image' && (
              <div className=' h-[500px]'>
              <div className=' flex justify-between p-2 bg-custom-gradient text-white'> <img
      src={logo}
      alt="Company Logo" // Update this to a meaningful description
      // className={` ${isLangArab?"":"sm:translate-x-3 -translate-x-5"}  w-full h-full object-contain`}
      className="w-28 h-[90%]"
      
    /><button 
            className=" flex justify-center items-center font-bold text-lg " 
            onClick={closeMediaPlayer}
          >
            <X className="w-6 h-6" />
          </button></div>
          <div className="w-full h-full bg-transparent flex justify-center items-center overflow-hidden">
              <img
                src={mediaSource}
                alt="Media"
                onLoad={(e) => {
                  const target = e.target;
                  const parent = target.parentElement;
            
                  if (parent) {
                    const naturalWidth = target.naturalWidth;
                    const naturalHeight = target.naturalHeight;
            
                    if (naturalHeight > parent.offsetHeight) {
                      target.style.height = "100%";
                      target.style.width = "auto";
                    } else if (naturalWidth > parent.offsetWidth) {
                      target.style.width = "100%";
                      target.style.height = "auto";
                    } else {
                      target.style.width = `${naturalWidth}px`;
                      target.style.height = `${naturalHeight}px`;
                    }
                  }
                }}
                className="max-w-full max-h-full object-contain"
              />
            </div>
              </div>
            )}
            {mediaType === 'video' && (
              <div>
                <div className=' flex justify-between p-2 bg-custom-gradient text-white'> <img
        src={logo}
        alt="Company Logo" // Update this to a meaningful description
        // className={` ${isLangArab?"":"sm:translate-x-3 -translate-x-5"}  w-full h-full object-contain`}
        className="w-28 h-[90%]"
        
      /><button 
              className=" flex justify-center items-center font-bold text-lg " 
              onClick={closeMediaPlayer}
            >
              <X className="w-6 h-6" />
            </button></div>
              <video
                id="media-element"
                src={mediaSource}
                controls
                autoPlay
                className="w-full h-auto max-h-[80vh]"
              />
              </div>
            )}
            {/* {mediaType === 'video' && (
              <div className="p-4 flex items-center justify-between">
                <button 
                  onClick={togglePlayPause} 
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  {isPlaying ? 'Pause' : 'Play'}
                </button>
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.01"
                  value={volume}
                  onChange={handleVolumeChange}
                  className="w-1/2"
                />
              </div>
            )} */}
          </div>
        </div>
      )}
   </>
  );
};
